import React from 'react'
import { Link } from 'react-router-dom'
import { Link as LinkScroll } from 'react-scroll'
import { useIntl } from 'react-intl'
import { Button } from '@mui/material'
import introImg from '../../../assets/img/landing/landing-advantages.png'
import '../style'
import {
    FlexBox,
    IntroContainer,
    IntroImg,
    LandingIntroDescription,
    LandingIntroImgBox,
    LandingIntroTitle,
    LandingIntroWrapper,
} from '../style'

function LandingIntro() {
    const { formatMessage } = useIntl()

    return (
        <IntroContainer>
            <LandingIntroWrapper>
                <LandingIntroImgBox>
                    <IntroImg
                        src={introImg}
                        alt="landing intro"
                    />
                </LandingIntroImgBox>

                <LandingIntroTitle>{formatMessage({ id: 'mainSlogan' })}</LandingIntroTitle>

                <LandingIntroDescription>
                    {formatMessage({ id: 'mainSubslogan' })}
                </LandingIntroDescription>

                <FlexBox>
                    <LinkScroll
                        to="courses"
                        smooth={true}
                        duration={500}
                        offset={-100}
                        style={{ width: 'inherit' }}
                    >
                        <Button
                            fullWidth={true}
                            size="large"
                            variant={'outlined'}
                        >
                            {formatMessage({ id: 'chooseCourse' })}
                        </Button>
                    </LinkScroll>
                    <a
                        href="https://api.whatsapp.com/send/?phone=77073081616&text=%D0%A1%D3%99%D0%BB%D0%B5%D0%BC%D0%B5%D1%82%D1%81%D1%96%D0%B7+%D0%B1%D0%B5%2C+%D0%BC%D0%B5%D0%BD+%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD+%D0%BA%D1%83%D1%80%D1%81%D2%9B%D0%B0+%D0%B6%D0%B0%D0%B7%D1%8B%D0%BB%D2%93%D1%8B%D0%BC+%D0%BA%D0%B5%D0%BB%D0%B5%D0%B4%D1%96&type=phone_number&app_absent=0"
                        target="_blank"
                        rel="noreferrer"
                        style={{ width: 'inherit' }}
                    >
                        <Button
                            fullWidth={true}
                            size="large"
                            variant={'contained'}
                        >
                            {formatMessage({ id: 'getFreeConsultation' })}
                        </Button>
                    </a>
                </FlexBox>
            </LandingIntroWrapper>
        </IntroContainer>
    )
}

export default LandingIntro
